export const ATTACHMENT = 'attachment';
export const IMAGE = 'image';
export const VIDEO = 'video';

export const CONTENT_TOO_LONG_ERROR = __(
  'Content is too long. (max characters: %{maxLength})',
);
